import { unwrapImageStyles } from "./CockpitUtils";
import cloneDeep from "lodash/cloneDeep";
import { add } from "./NumberUtils";

function isShippingLine(line: OrderLineDto) {
  return line.sku === "999111";
}

export function enhanceOrder(_order: OrderDto) {
  const order = cloneDeep(_order);
  order.lines = (order.lines || []).map(line => {
    line.images = (line.images || []).map(unwrapImageStyles);
    return line;
  });
  order.lines = order.lines.filter(line => {
    if (order.totals.shippingFee === "0" && isShippingLine(line)) {
      order.totals.shippingFee = line.price.price;
      order.totals.baseShippingFee = line.price.basePrice;
      order.totals.subTotal = add(
        order.totals.subTotal,
        `-${order.totals.shippingFee}`
      );
      order.totals.baseSubTotal = add(
        order.totals.baseSubTotal,
        `-${order.totals.baseShippingFee}`
      );
      return false;
    }
    return true;
  });
  return order;
}
